import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { TipoParticipacionRelevanteDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class TipoParticipacionRelevanteService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getTipoParticipacionRelevanteService(): Observable<BodyListResponse<TipoParticipacionRelevanteDTO>> {
    return this.http.get<BodyListResponse<TipoParticipacionRelevanteDTO>>(API_URL + '/api/v1/tipoParticipacionRelevante/todos');
  }

  guardarTipoParticipacionRelevanteService(tipoParticipacionRelevanteDTO: TipoParticipacionRelevanteDTO): Observable<TipoParticipacionRelevanteDTO> {
    return this.http.post<TipoParticipacionRelevanteDTO>(API_URL + '/api/v1/tipoParticipacionRelevante', tipoParticipacionRelevanteDTO);
  }

  getTipoParticipacionRelevantePorCodigoTipoParticipacionRelevanteService(codigoTipoParticipacionRelevante: string): Observable<BodyResponse<TipoParticipacionRelevanteDTO>> {
    return this.http.get<BodyResponse<TipoParticipacionRelevanteDTO>>(API_URL + '/api/v1/tipoParticipacionRelevante/' + codigoTipoParticipacionRelevante);
  }
}
